module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/inline-manifest-302.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/production/inline-manifest.md
// module id = 766
// module chunks = 432